"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shastaTokens = void 0;
exports.shastaTokens = {
    otherTokens: [{ name: 'WTRX', symbol: 'WTRX', decimals: 6, address: 'TF2ipqRnrDzuPrANJCJggmaM753FCE1ZWE' }]
};
